import { CommonButton } from "@components/CommonButton";
import report from "@report";
import { USER_BIZ_COUNTRY_MAP } from "@src/config/country";
import { updateSubscribeProducts } from "@store/memberCenterSlice";
import { Modal } from "antd";
import { Trans } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { formatCurrency, getGasStationPrice } from "@pages/pricing/utils";
import IndenpendentProduct from "./IndenpendentProduct";
import { pushGtmEvent } from "@utils/gtm";
import { GtmEvent } from "@utils/gtmEvents";

interface CreditModalProps {
  goPay: () => void;
}

const CreditModal = ({ goPay }: CreditModalProps) => {
  const dispatch = useAppDispatch();
  const { userInfo, language } = useAppSelector((state) => state.globalReducer);
  const { selectedProducts } = useAppSelector((state) => state.memberCenterReducer);

  const bizCountry = userInfo.bizCountry;

  const currency = "USD";
  return (
    <div>
      <Modal
        title={
          <div className="text-kds-fg font-bold text-[16px]">
            <Trans>Get More Credits</Trans>
          </div>
        }
        open={true}
        centered={true}
        onCancel={() => {
          dispatch(updateSubscribeProducts([]));
        }}
        styles={{ header: { marginBottom: 8 } }}
        footer={
          <div className="flex justify-end items-end gap-[16px]">
            {selectedProducts[0].quantity > 0 && (
              <>
                <div className="flex items-baseline gap-[4px]">
                  <span className="text-[14px] font-normal text-kds-fg-soft">
                    <Trans>Subtotal</Trans>
                  </span>
                  <div className="text-[24px] font-bold text-kds-fg leading-[24px]">
                    {formatCurrency(
                      getGasStationPrice(
                        selectedProducts[0].key,
                        USER_BIZ_COUNTRY_MAP[bizCountry],
                        currency,
                        selectedProducts[0].realprice,
                      ) * selectedProducts[0].quantity,
                      USER_BIZ_COUNTRY_MAP[bizCountry],
                      currency,
                      language,
                    )}
                  </div>
                </div>
              </>
            )}
            <CommonButton
              size="large"
              className="min-w-[144px]"
              disabled={selectedProducts[0].quantity === 0}
              onClick={() => {
                report.event("kalo_click", { kalo_type: "pay_for_ai_credits", kalo_value: "kaloclip" });
                pushGtmEvent(GtmEvent.PayNow);
                goPay();
              }}
              type="primary"
            >
              <Trans>Pay Now</Trans>
            </CommonButton>
          </div>
        }
      >
        <div className="text-kds-fg text-[14px]">
          <Trans>Top up your credits and gear up for your next viral hit!</Trans>
        </div>
        {selectedProducts.map((product, index) => {
          return <IndenpendentProduct key={product.itemId} product={product} index={index}></IndenpendentProduct>;
        })}
      </Modal>
    </div>
  );
};

export default CreditModal;
